import { render, staticRenderFns } from "./EditCostUnit.vue?vue&type=template&id=98eb1f94&"
import script from "./EditCostUnit.vue?vue&type=script&lang=js&"
export * from "./EditCostUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports